import { motion } from "framer-motion";
import { MapPin, Mountain, Coffee, Trees } from "lucide-react";
import { SITE } from "@/data/site";

const nearby = [
  { icon: MapPin, name: "MG Marg", time: "10 mins drive" },
  { icon: Coffee, name: "Café scene & boutiques", time: "12 mins drive" },
  { icon: Mountain, name: "Tashi Viewpoint", time: "20 mins drive" },
  { icon: Trees, name: "Hanuman Tok forest trail", time: "15 mins drive" },
];

export default function LocationSection() {
  return (
    <section id="location" data-testid="location-section" className="relative py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-5 flex flex-col justify-center">
            <div className="text-xs uppercase tracking-[0.22em] text-[#f5f0ea] font-semibold">
              Find us
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 tracking-tighter text-white">
              Mintogang. <br />
              <span className="text-[#A7D38B]">10 mins</span> from MG Marg.
            </h2>
            <p className="mt-5 text-neutral-400 max-w-md">
              Hidden enough to feel like an escape. Close enough to never miss
              Gangtok's pulse.
            </p>

            <div className="mt-8 space-y-3" data-testid="nearby-list">
              {nearby.map((n, i) => (
                <motion.div
                  key={n.name}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  className="flex items-center gap-3 rounded-2xl bg-white/[0.03] border border-white/5 px-4 py-3"
                >
                  <div className="w-9 h-9 rounded-xl bg-[#62794d]/20 text-[#A7D38B] flex items-center justify-center">
                    <n.icon size={16} />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm font-semibold text-white">{n.name}</div>
                    <div className="text-[11px] text-neutral-500">{n.time}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7 rounded-3xl overflow-hidden border border-white/5 min-h-[420px] relative"
            data-testid="map-embed"
          >
            <iframe
              title="GoNomikai location map"
              src={SITE.mapUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0 w-full h-full grayscale contrast-125"
              style={{ border: 0, filter: "invert(0.92) hue-rotate(180deg)" }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
